
import { computed, defineComponent, PropType, ref } from 'vue'
import { MarketplaceIntegration, MarketplaceIntegrationFeedback } from '../../../types/marketplace'
import IntegrationFeedbackCard from '../components/IntegrationFeedbackCard.vue'
import NoFeedback from './NoFeedback.vue'
import FeedbackModal from './FeedbackModal.vue'
import { useProject } from '../../../hooks/useProject'

export default defineComponent({
    props: {
        integration: {
            type: Object as PropType<MarketplaceIntegration>,
            required: true,
        },
        integrationFeedback: {
            type: Array as PropType<MarketplaceIntegrationFeedback[]>,
            required: true,
        },
    },
    components: { IntegrationFeedbackCard, NoFeedback, FeedbackModal },
    setup(props) {
        const { project } = useProject()
        const feedbackModalOpened = ref(false)

        const hasRating = computed(() => Number(props.integration.feedbackCount || 0) > 0)
        const ratingLabel = computed(() => Number(props.integration.feedbackRating || 0).toFixed(1))
        const feedbackCountLabel = computed(
            () => `${Number(props.integration.feedbackCount || 0)} отзывов`
        )

        const ratingDistribution = computed(() => {
            const rows = [5, 4, 3, 2, 1]
            const feedback = props.integrationFeedback || []
            const total = feedback.length
            return rows.map(n => {
                const count = feedback.filter(item => Math.round(Number(item.rating || 0)) === n).length
                const p = total ? Math.round((count / total) * 100) : 0
                return { n, p }
            })
        })

        const feedbackAlreadyExists = computed(() =>
            Boolean(props.integrationFeedback.find(el => el.projectId === project.value?.id))
        )
        const integrationInstalled = computed(() => props.integration.status === 'installed')
        const disabledButtonTooltipText = computed(() => {
            if (!integrationInstalled.value) return 'Отзывы станут доступны после покупки'
            if (feedbackAlreadyExists.value) return 'Отзыв уже оставлен'
            return ''
        })
        const installButtonDisabled = computed(
            () => feedbackAlreadyExists.value || !integrationInstalled.value
        )

        const openFeedbackModal = () => {
            feedbackModalOpened.value = true
        }

        return {
            feedbackModalOpened,
            openFeedbackModal,
            hasRating,
            ratingLabel,
            feedbackCountLabel,
            ratingDistribution,
            installButtonDisabled,
            disabledButtonTooltipText,
        }
    },
})
